module.exports = __webpack_public_path__ + "static/media/remove_book_1.ef68019a.png";